import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>Made with love &hearts;</div>
      <div>Sumanth T P &copy;</div>
    </footer>
  );
};

export default Footer;
